import { render } from "./SchemaEntryBlock.vue?vue&type=template&id=b0ae0784"
import script from "./SchemaEntryBlock.vue?vue&type=script&lang=js"
export * from "./SchemaEntryBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__